import { CellSimple, Switch } from "@maxhub/max-ui";

export const SwitchCellExample = {
    title: 'Cell with Switch',
    defaultPlatform: 'ios',
    defaultZoom: 100,


    controls: [],

    Preview({ props }){
        return (<CellSimple {...props} title="Cell" subtitle="Description" after={<Switch/>}/>)
    },

    getCode(){
        return `<CellSimple {...props} title="Cell" subtitle="Description" after={<Switch/>}/>`
    }
}